import React from 'react';
import { BrowserRouter, Routes, Route, Link, useNavigate, Navigate } from 'react-router-dom';
import cal from './cal.png';     // your existing icon
import auth from './auth.jpg';   // your existing icon
import studyIcon from './study.png'; // ← add your own flashcard/study icon here (or use any png)
import './App.css';
import CalCounter from './CalCounter.js';
import Study from './Study';     // new import
import LoginPage from './pages/LoginPage';
import CreateUserPage from './pages/CreateUserPage';
import ChatsPage from './pages/ChatsPage';
import UserPage from './pages/UserPage';
import Chat from "./pages/ChatPage";
import chatIcon from './chat.png';
import ProfilePage from './pages/ProfilePage';
import User_Page from './pages/User';
import Dm from "./pages/Dm"
import FollowingPage from "./pages/Following";
import FollowersPage from "./pages/Followers";
import Nav from './Nav';
import SearchPage from './pages/SearchPage';
// Cool Box component with hover effects (unchanged)
function Box({ name, icon, link, color }) {
  return (
    <Link to={link} className="box" style={{ '--box-color': color }}>
      <div className="box-inner">
        <img src={icon} alt={name} className="box-icon" />
        <h3 className="box-name">{name}</h3>
      </div>
      <div className="box-glow"></div>
    </Link>
  );
}

// Home page with clean design
function Home() {
  return (
    <div className="page">
      {/* Title Card */}
      <div className="title-card">
        <div className="title-card-content">
          <h1 className="main-title">
            <span className="title-word">KIRTAN'S </span>
            <span className="title-word gradient">PROJECTS</span>
          </h1>
          <div className="title-decoration">
            <span className="dot"></span>
            <span className="line"></span>
            <span className="dot"></span>
          </div>
        </div>
        <div className="title-card-bg">
          <div className="bg-shape shape1"></div>
          <div className="bg-shape shape2"></div>
          <div className="bg-shape shape3"></div>
        </div>
      </div>

      {/* Projects Grid */}
      <div className="projects-section">
        <div className="grid">
          <Box
            name="Calorie Counter"
            icon={cal}
            link="/cal-counter"
            color="#FF6B6B"
          />
          <Box
            name="Simple Auth"
            icon={auth}
            link="https://github.com/kirtan00001/Simple-Auth"
            color="#4ECDC4"
          />
          <Box
            name="Study Flashcards"
            icon={studyIcon}           // ← your new icon
            link="/study"
            color="#8b5cf6"
          />
          <Box
            name="Chats"
            icon={chatIcon}           // ← your new icon
            link="/chats"
            color="#8b5cf6"
          />
        </div>
      </div>
    </div>
  );
}

// CalCounter Page (unchanged)
function CalCounterPage() {
  const navigate = useNavigate();
  return (
    <div className="page subpage">
      <button className="back-button" onClick={() => navigate('/')}>
        ← Back
      </button>
      <CalCounter />
    </div>
  );
}

function ProtectedRouter({ children }) {
  const jwt = localStorage.getItem("jwt");
  const refresh = localStorage.getItem("refresh");

  if (!jwt || !refresh) {
    console.log("Not logged in, redirecting to login page");
    return <Navigate to="/login" replace />;
  }

  return children;
}

// New Study Page
function StudyPage() {
  const navigate = useNavigate();
  return (
    <div className="page subpage">
      <button className="back-button" onClick={() => navigate('/')}>
        ← Back
      </button>
      <Study />
    </div>
  );
}

// App with routing
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cal-counter" element={<CalCounterPage />} />
        <Route path="/study" element={<StudyPage />} />
        <Route path="/chats" element={<ChatsPage />} />

        <Route
          path="/"
          element={
            <ProtectedRouter>
              <Nav />
              <UserPage />
            </ProtectedRouter>
          }
        />
        <Route
          path="/dm"
          element={
            <ProtectedRouter>
              <Nav />
              <Dm />
            </ProtectedRouter>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sign-up" element={<CreateUserPage />} />
        <Route
          path="/chats"
          element={
            <ProtectedRouter>
              <Nav />
              <ChatsPage />
            </ProtectedRouter>
          }
        />
        <Route
          path="/chat"
          element={
            <ProtectedRouter>
              <Nav />
              <Chat />
            </ProtectedRouter>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRouter>
              <Nav />
              <ProfilePage />
            </ProtectedRouter>
          }
        />
        <Route
          path="/user"
          element={
            <ProtectedRouter>
              <Nav />
              <User_Page />
            </ProtectedRouter>
          }
        />
        <Route
          path="/following"
          element={
            <ProtectedRouter>
              <Nav />
              <FollowingPage />
            </ProtectedRouter>
          }
        />
        <Route
          path="/followers"
          element={
            <ProtectedRouter>
              <Nav />
              <FollowersPage />
            </ProtectedRouter>
          }
        />
        <Route
          path="/search"
          element={
            <ProtectedRouter>
              <Nav />
              <SearchPage />
            </ProtectedRouter>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;